import { render } from "./Menu.vue?vue&type=template&id=9baca258&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=9baca258&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9baca258"

export default script